document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.ugc-section__container');

  containers.forEach(container => {
    let flkty = null;
    const slider = container.querySelector('.ugc-section__slider');
    const items = slider.querySelectorAll('.ugc-section__item');
    const customDots = document.querySelector('.ugc-dots');

    if (!slider || items.length < 2) {
      if (customDots) customDots.style.display = 'none';
      return;
    }
  
    function enableFlickity() {
      if (items.length > 2 && window.innerWidth < 990 && !slider.classList.contains('flickity-enabled')) {
        flkty = new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          wrapAround: false,
          lazyLoad: 2,
          prevNextButtons: false,
        });

        if (customDots) {
          customDots.innerHTML = '';
          
          flkty.cells.forEach((cell, index) => {
            const dot = document.createElement('span');
            dot.classList.add('slider-dot');
            if (index === flkty.selectedIndex) dot.classList.add('is-active');
    
            dot.addEventListener('click', () => flkty.select(index));
            customDots.appendChild(dot);
          });
    
          flkty.on('change', function (index) {
            const allDots = customDots.querySelectorAll('.slider-dot');
            allDots.forEach((dot, i) => {
              dot.classList.toggle('is-active', i === index);
            });
          });
        }
      }
    }
  
    function destroyFlickity() {
      if (window.innerWidth >= 990 && flkty) {
        flkty.destroy();
        flkty = null;
      }
    }
  
    function handleResize() {
      enableFlickity();
      destroyFlickity();
    }
  
    enableFlickity();
    window.addEventListener('resize', handleResize);
  });
});
